<script lang="ts">

    import 'swiper/css/bundle';
    import { afterUpdate, createEventDispatcher, onMount, setContext } from 'svelte';
    import { Swiper, Lazy, Pagination } from 'swiper';
    import type { LazyOptions, PaginationOptions } from 'swiper/types';

    Swiper.use([Lazy, Pagination]);

    export let slideTo: any = null;
    export let autoHeight: boolean = false;
    export let preloadImages: boolean = true;
    export let lazy: boolean | LazyOptions = false;
    export let activeIndex: number = -1;
    export let pagination: boolean | PaginationOptions = false;
    export let slidesPerView: number | 'auto' = 1;
    export let slidesPerGroup: number = 1;

    const slidesMap = new Map<any, HTMLElement>();
    const dispatch = createEventDispatcher();

    let swiperContainer: HTMLElement;
    let swiper: Swiper;

    $: slideToIndex(slideTo);

    setContext('registerSlide', (slideIndex: any, slideElement: HTMLElement) => {
        if (!slideIndex || slidesMap.has(slideIndex)) {
            return;
        }
        slidesMap.set(slideIndex, slideElement);
        if (slideIndex === slideTo) {
            slideToIndex(slideIndex);
        }
        swiper?.update();
    });

    setContext('unregisterSlide', (index: any) => {
        slidesMap.delete(index);
    });

    onMount(() => {

        const paginationDefaults: PaginationOptions = { el: '.swiper-pagination' };
        let paginationOptions: boolean | PaginationOptions = false;
        
        if (pagination === true) {
            paginationOptions = paginationDefaults;
        } else if (pagination) {
            paginationOptions = { ...pagination, ...paginationDefaults };
        }

        swiper = new Swiper(swiperContainer, {
            autoHeight,
            preloadImages,
            lazy,
            pagination: paginationOptions,
            slidesPerView,
            slidesPerGroup,
            on: {
                slideChange: onSlideChange,
                slideChangeTransitionEnd: () => {
                    console.log('slideChangeTransitionEnd');
                    swiper.updateAutoHeight();
                },
            }
        });

        if (slideTo) {
            slideToIndex(slideTo);
        }

    });

    afterUpdate(() => {
        update();
    });

    export function update() {
        swiper?.update();
    }

    export function next() {
        swiper?.slideNext();
    }

    export function prev() {
        swiper?.slidePrev();
    }

    function onSlideChange() {

        activeIndex = swiper.activeIndex;

        const slideElement = swiper.slides[swiper.activeIndex] as HTMLElement;

        //Obtenemos el indice del slider actual
        const [index] = [...slidesMap].find(([, el]) => el === slideElement) || [];

        if (!index) {
            return;
        }

        dispatch('change', index);
    }

    function slideToIndex(index: any) {
        if (!swiper || !index) {
            return;
        }
        const slideElement = slidesMap.get(index);
        const slideIndex = swiper.slides.indexOf(slideElement);
        swiper.slideTo(slideIndex, 0);
        activeIndex = slideIndex;
        dispatch('change', index);
    }

</script>

<style lang="scss">

    .swiper-container {
        flex: 1 1 0;
        height: var(--height, auto);
        min-height: var(--min-height, auto);
        width: 100%;
        touch-action: auto;
        pointer-events: auto;
        overflow: hidden;
    }

</style>

<div class="swiper-container" bind:this={swiperContainer}>
    <div class="swiper-wrapper">
        <slot></slot>
    </div>
    <div class="swiper-pagination"></div>
</div>
